var lib_core = require("lib-core");

var showUI;
if(showUI = (typeof window !== 'undefined'))
    var ui_extensions = require("ui-extensions");

var ToolbarModeModel = require("./toolbarModeModel.js");

var ToolbarModeController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(ToolbarModeController, lib_core.Controller);
if(showUI) {
    ToolbarModeController.inject = {
        toolbarController : ui_extensions.ToolbarController,
    };
}

module.exports = ToolbarModeController;

ToolbarModeController.prototype.beforeLoad = function () {
    this.toolbarController.registerMode(this);
};

ToolbarModeController.prototype.getStatemachine = function () {
    return this.toolbarController.getStatemachine();
};

ToolbarModeController.prototype.appendToParentSM = function () {};

ToolbarModeController.prototype.createModel = function () {
    if (this.configuration && this.configuration.viewOnly && this.configuration.viewOnly === true) {
        return null;
    } else {
        return new ToolbarModeModel();
    }
};

ToolbarModeController.prototype.registerTool = function (tool) {
    return this.getModel().registerTool(tool);
};
